var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "white",
    stroke: "#E4E4E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 10.499H10.5V12.999C10.5 13.1316 10.4473 13.2588 10.3536 13.3526C10.2598 13.4463 10.1326 13.499 10 13.499C9.86739 13.499 9.74021 13.4463 9.64645 13.3526C9.55268 13.2588 9.5 13.1316 9.5 12.999V10.499H7C6.86739 10.499 6.74021 10.4463 6.64645 10.3526C6.55268 10.2588 6.5 10.1316 6.5 9.99902C6.5 9.86642 6.55268 9.73924 6.64645 9.64547C6.74021 9.5517 6.86739 9.49902 7 9.49902H9.5V6.99902C9.5 6.86642 9.55268 6.73924 9.64645 6.64547C9.74021 6.5517 9.86739 6.49902 10 6.49902C10.1326 6.49902 10.2598 6.5517 10.3536 6.64547C10.4473 6.73924 10.5 6.86642 10.5 6.99902V9.49902H13C13.1326 9.49902 13.2598 9.5517 13.3536 9.64547C13.4473 9.73924 13.5 9.86642 13.5 9.99902C13.5 10.1316 13.4473 10.2588 13.3536 10.3526C13.2598 10.4463 13.1326 10.499 13 10.499Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddButton);
export default __webpack_public_path__ + "static/media/add_button.6aa5e4c435d89e377c5afde229a9a6b2.svg";
export { ForwardRef as ReactComponent };